import { Header } from "../components/Header";
import { Hero } from "../components/Hero";
import { WhereAudioGoes } from "../components/WhereAudioGoes";
import { Problem } from "../components/Problem";
import { EnglishBarrier } from "../components/EnglishBarrier";
import { UseCases } from "../components/UseCases";
import { CopilotFeature } from "../components/CopilotFeature";
import { HowItWorks } from "../components/HowItWorks";
import { Differentiation } from "../components/Differentiation";
import { Features } from "../components/Features";
import { Personas } from "../components/Personas";
import { PrivacySection } from "../components/PrivacySection";
import { Pricing } from "../components/Pricing";
import { Faq } from "../components/Faq";
import { FooterCta } from "../components/FooterCta";
import { Footer } from "../components/Footer";
import { Reveal } from "../components/Reveal";
import { SeoForPage } from "../components/Seo";

export function Landing() {
  return (
    <div className="min-h-screen flex flex-col">
      <SeoForPage
        page="landing"
        path="/"
        schema={["softwareApplication", "faqPage"]}
      />
      <Header />
      {/* Hero is above the fold; don't wrap it in <Reveal> to avoid a first-
          paint flash. Every section below fades + slides up on scroll in. */}
      <main className="flex-1">
        <Hero />
        <Reveal><Problem /></Reveal>
        <Reveal><EnglishBarrier /></Reveal>
        <Reveal><UseCases /></Reveal>
        <Reveal><CopilotFeature /></Reveal>
        <Reveal><WhereAudioGoes /></Reveal>
        <Reveal><HowItWorks /></Reveal>
        <Reveal><Differentiation /></Reveal>
        <Reveal><Features /></Reveal>
        <Reveal><Personas /></Reveal>
        <Reveal><PrivacySection /></Reveal>
        <Reveal><Pricing /></Reveal>
        <Reveal><Faq /></Reveal>
        <Reveal><FooterCta /></Reveal>
      </main>
      <Footer />
    </div>
  );
}
